import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const GoodDeathForm = ({ prompt, onSubmit, lifeform }) => {
  const [lengthErr, setLengthErr] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ mode: 'onChange', reValidateMode: 'onChange'})

  const watchedText = watch(["maintext"]);

  useEffect(() => {
    if(watchedText.length > 0) {
      if(watchedText[0] && watchedText[0].length > 300) {
        setLengthErr(true);
      } else {
        setLengthErr(false);
      }
    }
  }, [watchedText, setLengthErr, errors]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <p>{prompt}</p>
      <p><input className="text" {...register("maintext", { pattern: /^[\x00-\x7F]*$/ })} /></p>
      {/* errors will return when field validation fails  */}
      {errors.maintext && <p><span className="error">Sorry, only ascii characters allowed</span></p>}
      {lengthErr && <p><span className="error">Currently your response is too long and will become very expensive to mint</span></p>}
      <div className="button-parent"><input type="submit" value="Generate metadata"/></div>
    </form>
  )
}

export default GoodDeathForm;